<template>
    <el-card class="fitness-index member-card">
        <el-table
            border
            ref="tableData"
            v-if="tableData"
            :data="tableData"
            v-loading="loading"
            @row-click="clickRow"
            @selection-change="handleSelectChange"
        >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="id" :label="$t('Card.id')" align="center" width="50px" v-if="false"/>
            <el-table-column prop="number" :label="$t('Common.number')" align="center" width="100px"/>
            <el-table-column prop="name" :label="$t('Reception.First.card_name')" align="center"/>
            <el-table-column prop="cardType" :label="$t('Card.type')" align="center"/>
            <el-table-column prop="validPeriod" :label="$t('Sell.Validity_period(days)')" align="center"/>
            <el-table-column prop="count" :label="$t('Lesson.frequency')" align="center" width="80px"/>
            <el-table-column prop="basePrice" :label="$t('Card.sell_base_amt')" align="center" width="100px">
                <template slot-scope="{$index, row}">¥ {{ row.basePrice }}</template>
            </el-table-column>
            <el-table-column prop="transferFee" :label="$t('Reception.Fifth.fee')" align="center" width="100px"/>
            <el-table-column prop="saleStatus" :label="$t('Sell.Selling_status')" align="center" width="100px">
                <template slot-scope="{row}">
                    <span :class="row.saleStatus === 1 ? 'task-status' : 'del-status'">
                        {{ row.saleStatusName }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="experienceCard" :label="$t('Card.Is_experience_card')" align="center" width="100px">
                <template slot-scope="{$index, row}">
                    {{ row.experienceCard === 1 ? $t('Common.yes') : $t('Common.no') }}
                </template>
            </el-table-column>
            <el-table-column prop="saleBegin" :label="$t('Fill.Start_time_sell')" align="center" width="100px"/>
            <el-table-column prop="saleEnd" :label="$t('Fill.SaleEndTime')" align="center" width="100px"/>
            <el-table-column prop="sellStores" :label="$t('Sell.StoreList')" align="center" width="120px"/>
            <el-table-column prop="supportStores" :label="$t('Sell.Admission_list')" align="center" width="120px"/>
            <el-table-column prop="enterTimes" :label="$t('Sell.Restriction_of_time')" align="center" width="100px"/>
            <el-table-column prop="remark" :label="$t('Common.remark')" align="center" width="110px"/>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            v-if="tableData"
            class="text-right mt-5"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
        <!-- 限制入场时间弹窗 -->
        <approach-time-form ref="approach" v-model="input"/>
        <!-- 新增/编辑弹窗 -->
        <stored-value-card-form ref="card" @fetchData="fetchData" :activeName="activeName" />
    </el-card>
</template>

<script>
import { Dialog, DatePicker, Row } from 'element-ui';
import ApproachTimeForm from '@/components/Dialog/Sell/ApproachTimeForm';
import StoredValueCardForm from '@/components/Dialog/Sell/StoredValueCardForm';

export default {
    props: ['activeName', 'stores', 'form', 'date'],
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRow: Row,
        ApproachTimeForm,
        StoredValueCardForm,
    },
    data() {
        return {
            cardSettingForm: {},
            storeIds: [],
            addTime: false,
            input: '',
            id: '',
            form_loading: false,
            record_visible: false,
            visible: false,
            loading: false,
            tableData: [],
            records: [],
            cardIds: [],
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
        };
    },
    computed: {},
    mounted() {},
    watch: {
        activeName(val) {
            if (val === 'memberCard') this.fetchData();
        },
        input(val) {
            if (val) this.fetchData();
        },
    },
    methods: {
        fetchData(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get('member-card/pages', {
                params: {
                    ...this.form,
                    ...this.pagination,
                    storeIds: this.form.storeId ? this.form.storeId : null,
                    saleBegin: this.date && this.date.length ? this.date[0] : null,
                    saleEnd: this.date && this.date.length ? this.date[1] : null,
                    cardType: this.form.cardTypeCode,
                },
            }).then(res => {
                this.input = '';
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                const msg = `${this.$t('Charge.search')}：共${res.totalElements}条记录`;
                this.$emit('input', msg);
            }).finally(() => {
                this.loading = false;
            });
        },
        flush(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get('member-card/pages', {
                params: {
                    ...this.pagination,
                    statusCode: 1,
                },
            }).then(res => {
                this.input = '';
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                const msg = `${this.$t('Charge.search')}：共${res.totalElements}条记录`;
                this.$emit('input', msg);
            }).finally(() => {
                this.loading = false;
            });
        },
        handleEdit(data) {
            if (data && this.validSelect()) {
                if (this.$$filterPermission('售卖-会籍卡/储值卡管理-添加、修改会籍卡/储值卡'))
                this.$refs.card.open(this.cardIds[0]);
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
            if (!data) {
                if (this.$$filterPermission('售卖-会籍卡/储值卡管理-添加、修改会籍卡/储值卡'))
                this.$refs.card.open();
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        submit() {
            this.$refs.cardSetting.validate(valid => {
                if (valid) {
                    if (this.id) this.putData();
                    else this.postData();
                } else {
                    $ele.$message('请输入完整信息！');
                    return false;
                }
            });
        },
        putData() {
            API.put(`card-number-setting/${this.id}`, this.cardSettingForm)
                .then(() => {
                    $ele.$message.success(this.$t('Message.save'));
                    this.fetchData();
                })
                .finally(() => {
                    this.loading = false;
                    this.form_loading = false;
                    this.visible = false;
                })
                .catch(err => {
                    $ele.$message.error(err);
                });
        },
        postData() {
            API.post('card-number-setting', this.cardSettingForm)
                .then(() => {
                    $ele.$message.success(this.$t('Message.save'));
                    this.fetchData();
                })
                .finally(() => {
                    this.loading = false;
                    this.form_loading = false;
                    this.visible = false;
                })
                .catch(err => {
                    $ele.$message.error(err);
                });
        },
        handleForbidden() {
            if (this.validSelect()) {
                if (this.$$filterPermission('售卖-会籍卡/储值卡管理-添加、修改会籍卡/储值卡')) {
                    $ele.$confirm('确认禁售这个会籍卡?', this.$t('Common.tip'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        cancelButtonText: this.$t('Common.cancel'),
                        type: 'warning',
                    }).then(() => {
                        API.delete(`member-card/${this.cardIds[0]}/active`)
                            .then(() => {
                                $ele.$message.success(this.$t('Message.Successful_sale_ban'));
                                this.fetchData();
                            });
                    }).catch(() => {
                        $ele.$message.info(this.$t('Message.Cancelled'));
                    });
                } else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        handleRestore() {
            if (this.validSelect()) {
                $ele.$confirm('确认恢复这个会籍卡?', this.$t('Common.tip'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                }).then(() => {
                    if (this.$$filterPermission('售卖-会籍卡/储值卡管理-添加、修改会籍卡/储值卡')) {
                        API.put(`member-card/${this.cardIds[0]}/active`).then(() => {
                            $ele.$message.success(this.$t('Common.message.successRestore'));
                            this.fetchData();
                        });
                    } else {
                        $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                            confirmButtonText: this.$t('Message.confirm'),
                            callback: action => {},
                        });
                    }
                }).catch(() => {
                    $ele.$message.info(this.$t('Common.message.cancelRestore'));
                });
            }
        },
        handleReset() {
            this.form = {};
            this.fetchData(1);
        },
        approachTime() {
            if (this.validSelect()) {
                if (this.$$filterPermission('售卖-会籍卡/储值卡管理-添加、修改会籍卡/储值卡'))
                this.$refs.approach.open(this.cardIds[0]);
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }

        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        handleSelectChange(val) {
            this.cardIds = val.map(el => el.id);
        },
        validSelect() {
            if (this.cardIds.length > 1) {
                $ele.$message.warning(this.$t('Message.once_data'));
            }
            if (this.cardIds.length < 1) $ele.$message.warning(this.$t('Message.Please_select_a_data'));
            else return true;
        },
    },
    created() {
        if (this.activeName === 'memberCard') this.fetchData();
    },
};
</script>
<style lang="scss">
.member-card {
    .icon {
        position: absolute !important;
        right: 0px;
        display: inline;
    }
    .title-3a {
        height: 20px;
        color: grey;
        line-height: 10px;
        font-size: 12px;
        font-weight: 400;
    }
    .task-status {
        color: #2a9546;
    }
    .del-status {
        color:#ce6969;
    }
}
</style>
